import { render } from "./MintOrReserveBanner.vue?vue&type=template&id=65b0aa54"
import script from "./MintOrReserveBanner.vue?vue&type=script&lang=js"
export * from "./MintOrReserveBanner.vue?vue&type=script&lang=js"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/home/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__